<script>
import lazysizes from "lazysizes";
import Sidebar from "./components/Sidebar";
import Result from "./components/Result";
import NoResult from "./components/NoResult";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "app",
  components: {
    Sidebar,
    Result,
    NoResult,
  },

  computed: {
    ...mapGetters({
      urlPrefix: "getUrlPrefix",
      tourCategoryId: "getTourCategoryId",
      filterUrlPrefix: "getFilterUrlPrefix",
      totalCount: "getTotalCount",
      loading: "getLoading",
    }),
  },

  methods: {
    ...mapActions(["fetchFilterData", "fetchFilters"]),
  },

  created() {
    lazysizes.init();
    this.fetchFilterData(this.urlPrefix + this.tourCategoryId);
  },
};
</script>

<style lang="scss">
@import "./style/modules/_tourList.scss";
</style>

<template>
  <div class="container px--0">
    <div v-if="loading || totalCount" class="tour-list">
      <Sidebar />

      <Result />
    </div>

    <NoResult v-else />
  </div>
</template>
